import { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Input, Modal, Row, Select, notification } from "antd";
import createAxiosInstanceNew from "../../../Api/AxiosInstance/AxiosInstance";
import { UseUser } from "../../../hooks";

export default function UpdateStatusFaltanteModal(props) {
  const { updateStatusModal, setUpdateStatusModal, onRefetch } = props;

  const { displayName } = UseUser();

  const [statusToModify, setStatusToModify] = useState(0);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (updateStatusModal.open) {
      if (
        updateStatusModal.currentStatus === 4 ||
        updateStatusModal.currentStatus === 5 ||
        updateStatusModal.currentStatus === 6
      ) {
        setStatusToModify(updateStatusModal.currentStatus);
      } else {
        setStatusToModify(0);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateStatusModal.open]);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const handleUpdate = async () => {
    setLoading(true);
    const data = {
      FCCODIGOFALTANTE: updateStatusModal.faltanteCode,
      FIESTATUSID: statusToModify,
      FCSEGUIMIENTOANALISTA: updateStatusModal.updateComment,
      FCUSUARIO: displayName || "Usuario",
    };

    const axiosInstance = await createAxiosInstanceNew();

    try {
      const res = await axiosInstance.put("faltante", data);

      if (res.data.statusCode === 200 || res.status === 200) {
        openNotificationWithIcon("success", "Estatus actualizado correctamente");
        setUpdateStatusModal({
          faltanteCode: "",
          currentStatus: 0,
          updateComment: "",
          open: false,
        });

        onRefetch();
      } else {
        openNotificationWithIcon("error", "Error al actualizar el estatus");
      }
    } catch (error) {
      throw new Error(`error: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  const isDisabled =
    updateStatusModal.updateComment === null ||
    updateStatusModal.updateComment === "" ||
    statusToModify === 0 ||
    statusToModify === updateStatusModal.currentStatus
      ? true
      : false;

  const isClarified = updateStatusModal.currentStatus === 4;
  const isCanceled = updateStatusModal.currentStatus === 7;

  return (
    <>
      {contextHolder}
      <Modal
        open={updateStatusModal.open}
        onCancel={() =>
          setUpdateStatusModal({
            faltanteCode: "",
            currentStatus: 0,
            updateComment: "",
            open: false,
          })
        }
        footer={null}
      >
        <Row justify="space-around">
          <Col span={24}>
            <div className="input-content-titulo">Actualizar estatus de faltante</div>
          </Col>
          {isClarified && (
            <Col span={11}>
              <Alert description="Faltante aclarado." type="success" showIcon />
            </Col>
          )}
          {isCanceled && (
            <Col span={11}>
              <Alert description="Faltante cancelado." type="error" showIcon />
            </Col>
          )}

          <Col xs={20} md={22} className="mt-3" al>
            <label className="text-context-inputs">Estatus:</label>

            <Form.Item>
              <Select
                onChange={(value) => setStatusToModify(value)}
                value={statusToModify}
                disabled={isClarified || isCanceled}
              >
                <Select.Option key={0} value={0} disabled>
                  Selecciona
                </Select.Option>
                <Select.Option key={4} value={4}>
                  Aclarado
                </Select.Option>
                <Select.Option key={5} value={5}>
                  Incobrable
                </Select.Option>
                <Select.Option key={6} value={6}>
                  Seguimiento CxC
                </Select.Option>
                <Select.Option key={7} value={7}>
                  Cancelado
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={20} md={22} className="mt-3" al>
            <label className="text-context-inputs">Nota:</label>

            <Form.Item>
              <Input
                value={updateStatusModal.updateComment}
                onChange={(e) =>
                  setUpdateStatusModal((prev) => ({
                    ...prev,
                    updateComment: e.target.value,
                  }))
                }
                placeholder="Seguimiento del analista"
              ></Input>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-evenly" align="bottom">
          <Col xs={20} md={10} className="mt-3" al>
            <Button
              onClick={() =>
                setUpdateStatusModal({
                  faltanteCode: "",
                  currentStatus: 0,
                  updateComment: "",
                  open: false,
                })
              }
              variant="primary"
              danger
              className="button-styles-cancel"
            >
              Cancelar
            </Button>
          </Col>
          <Col xs={20} md={10} className="mt-3" al>
            <Button
              onClick={handleUpdate}
              type="primary"
              className="button-styles-add-element"
              disabled={isDisabled || isCanceled || isClarified || loading}
              loading={loading}
            >
              Actualizar
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
}
